(function () {
  const root = document.getElementById('spf-root');
  if (!root) return;

  const dataEl = document.getElementById('spf-product-data');
  let products = [];
  try {
    products = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('SKINS Product Finder: could not parse product data', e);
    return;
  }

  // ---- Tracking -----------------------------------------------------------
  // Publishes custom events that the "Fit Finder" custom pixel forwards to GA4.
  function trackFinder(eventName, data = {}) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(eventName, data);
      }
    } catch (e) {}
  }

  let finderStarted = false; // fit_finder_start fires once per run-through
  let cartTagged = false;    // cart attribute is only set once per page load

  function trackStartOnce() {
    if (finderStarted) return;
    finderStarted = true;
    trackFinder('fit_finder_start');
  }

  // Marks the cart so any resulting order shows "fit_finder: yes"
  // under Additional details in Shopify admin.
  function tagCart() {
    if (cartTagged) return;
    cartTagged = true;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { fit_finder: 'yes' } }),
        keepalive: true, // lets the request finish while the product page loads
      });
    } catch (e) {}
  }
  // -------------------------------------------------------------------------

  const PERFORMANCE_ACTIVITIES = [
    'Running',
    'Cycling',
    'Gym & Training',
    'Team & Racket Sports',
    'Athletics',
    'Yoga & Pilates',
    'Snowsports',
  ];

  const stepEls = Array.from(root.querySelectorAll('.spf__step'));
  const stepByKey = {};
  stepEls.forEach((el) => { stepByKey[el.dataset.key] = el; });

  const resultsPanel = root.querySelector('.spf__results');
  const progressBarWrap = root.querySelector('.spf__progress');
  const progressBar = document.getElementById('spf-progress-bar');
  const stepLabel = document.getElementById('spf-step-label');
  const backBtn = document.getElementById('spf-back');
  const restartBtn = document.getElementById('spf-restart');
  const grid = document.getElementById('spf-grid');
  const emptyMsg = document.getElementById('spf-empty');
  const loadMoreBtn = document.getElementById('spf-load-more');
  const resultsTitle = document.getElementById('spf-results-title');
  const breadcrumb = document.getElementById('spf-breadcrumb');
  const submitBtn = document.getElementById('spf-submit');
  const skipBtn = document.getElementById('spf-skip');

  const FIELD_LABELS = {
    purpose: 'For',
    frequency: 'Training',
    gender: 'Shopping for',
    types: 'Garments',
  };

  const BASE_SEQUENCE = ['purpose', 'frequency', 'gender', 'types'];

  const answers = { purpose: null, frequency: null, gender: null, types: [] };
  const answerLabels = { purpose: null, frequency: null, gender: null, types: null };
  let visibleSequence = BASE_SEQUENCE.slice();
  let currentKey = 'purpose';
  let visibleCount = 6;
  const PAGE_SIZE = 6;
  let currentMatches = [];

  function updateSequence() {
    visibleSequence = BASE_SEQUENCE.slice();
  }

  function renderBreadcrumb() {
    const crumbs = visibleSequence
      .map((field) => {
        if (!answerLabels[field]) return '';
        return `<button type="button" class="spf__crumb" data-jump="${field}"><span class="spf__crumb-label">${FIELD_LABELS[field]}:</span> ${escapeHtml(answerLabels[field])}</button>`;
      })
      .filter(Boolean)
      .join('');
    breadcrumb.innerHTML = crumbs;
    breadcrumb.querySelectorAll('.spf__crumb').forEach((btn) => {
      btn.addEventListener('click', () => showStepByKey(btn.dataset.jump));
    });
  }

  function showStepByKey(key) {
    stepEls.forEach((el) => el.classList.toggle('is-active', el.dataset.key === key));
    resultsPanel.classList.remove('is-active');
    currentKey = key;
    const idx = visibleSequence.indexOf(key);
    const total = visibleSequence.length;
    const pct = ((idx + 1) / total) * 100;
    progressBar.style.width = pct + '%';
    progressBarWrap.setAttribute('aria-valuenow', idx + 1);
    progressBarWrap.setAttribute('aria-valuemax', total);
    stepLabel.textContent = 'Step ' + (idx + 1) + ' of ' + total;
    backBtn.style.display = idx === 0 ? 'none' : 'inline-block';
    renderBreadcrumb();
  }

  function goNext() {
    updateSequence();
    const idx = visibleSequence.indexOf(currentKey);
    if (idx < visibleSequence.length - 1) {
      showStepByKey(visibleSequence[idx + 1]);
    } else {
      showResults();
    }
  }

  function goBack() {
    const idx = visibleSequence.indexOf(currentKey);
    if (idx > 0) showStepByKey(visibleSequence[idx - 1]);
  }

  stepEls.forEach((step) => {
    const optionsEl = step.querySelector('.spf__options');
    const field = optionsEl.dataset.field;
    const isMulti = optionsEl.dataset.multi === 'true';

    optionsEl.querySelectorAll('.spf__option').forEach((btn) => {
      btn.addEventListener('click', () => {
        trackStartOnce();

        if (isMulti) {
          const val = btn.dataset.value;
          const idx = answers.types.indexOf(val);
          if (idx > -1) {
            answers.types.splice(idx, 1);
            btn.classList.remove('is-selected');
            btn.setAttribute('aria-pressed', 'false');
          } else {
            answers.types.push(val);
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          }
          answerLabels.types = answers.types.length ? answers.types.join(', ') : null;
          // The garment step is tracked when they submit or skip, not on every toggle
        } else {
          optionsEl.querySelectorAll('.spf__option').forEach((b) => {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          answers[field] = btn.dataset.value || null;
          const titleEl = btn.querySelector('.spf__option-title');
          answerLabels[field] = titleEl ? titleEl.textContent : btn.textContent.trim();
          trackFinder('fit_finder_step', { step: field, answer: answers[field] || 'none' });
          setTimeout(goNext, 150);
        }
      });
    });
  });

  submitBtn.addEventListener('click', () => {
    trackStartOnce();
    trackFinder('fit_finder_step', {
      step: 'types',
      answer: answers.types.length ? answers.types.join(', ') : 'any',
    });
    showResults();
  });

  skipBtn.addEventListener('click', () => {
    trackStartOnce();
    answers.types = [];
    answerLabels.types = null;
    root.querySelectorAll('[data-field="types"] .spf__option').forEach((b) => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    trackFinder('fit_finder_step', { step: 'types', answer: 'skipped' });
    showResults();
  });

  backBtn.addEventListener('click', goBack);

  restartBtn.addEventListener('click', () => {
    trackFinder('fit_finder_restart');
    finderStarted = false; // the next run-through counts as a new start
    answers.purpose = null;
    answers.frequency = null;
    answers.gender = null;
    answers.types = [];
    answerLabels.purpose = null;
    answerLabels.frequency = null;
    answerLabels.gender = null;
    answerLabels.types = null;
    root.querySelectorAll('.spf__option').forEach((b) => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    visibleCount = PAGE_SIZE;
    updateSequence();
    showStepByKey('purpose');
  });

  loadMoreBtn.addEventListener('click', () => {
    visibleCount += PAGE_SIZE;
    renderGrid();
  });

  // One listener on the grid catches clicks on any result card,
  // including cards added later by "Load more".
  grid.addEventListener('click', (e) => {
    const card = e.target.closest('.spf__card');
    if (!card) return;
    trackFinder('fit_finder_product_click', {
      product: card.dataset.title || '',
      position: Number(card.dataset.position) || 0,
    });
    tagCart();
  });

  function purposeMatches(p) {
    const acts = p.activities || [];
    if (answers.purpose === 'performance') {
      return acts.some((a) => PERFORMANCE_ACTIVITIES.includes(a));
    }
    if (answers.purpose === 'travel_recovery') {
      return acts.includes('Recovery & Travel');
    }
    if (answers.purpose === 'both') {
      return acts.includes('Recovery & Travel') || acts.some((a) => PERFORMANCE_ACTIVITIES.includes(a));
    }
    return true;
  }

  // How well a product's compression fits the chosen activity level.
  // 0 = best fit, 1 = neighbouring tier (still shown, ranked after), null = doesn't fit.
  const FREQUENCY_FIT = {
    '1-3': { best: ['Low', 'Medium'], also: ['Medium-High'] },
    '3-5': { best: ['Medium-High'], also: ['Medium', 'High'] },
    '5-7': { best: ['High', 'Medium-High'], also: [] },
  };

  function fitScore(p) {
    const fit = FREQUENCY_FIT[answers.frequency];
    if (!fit) return 0;
    if (fit.best.includes(p.compression)) return 0;
    if (answers.frequency === '1-3' && (p.activities || []).includes('Everyday')) return 0;
    if (fit.also.includes(p.compression)) return 1;
    return null;
  }

  function frequencyMatches(p) {
    return fitScore(p) !== null;
  }

  function genderMatches(p) {
    if (!answers.gender) return true;
    const g = p.genders || [];
    return g.includes(answers.gender) || g.includes('Unisex');
  }

  function typeMatches(p) {
    if (!answers.types.length) return true;
    return answers.types.includes(p.type);
  }

  function matchesFilters(p, relaxType, relaxFrequency, relaxPurpose, relaxGender) {
    if (!relaxPurpose && answers.purpose && !purposeMatches(p)) return false;
    if (!relaxFrequency && answers.frequency && !frequencyMatches(p)) return false;
    if (!relaxGender && !genderMatches(p)) return false;
    if (!relaxType && !typeMatches(p)) return false;
    return true;
  }

  function findMatches() {
    // matchesFilters(p, relaxType, relaxFrequency, relaxPurpose, relaxGender)
    let matches = products.filter((p) => matchesFilters(p, false, false, false, false));
    let relaxedNote = '';

    // If garments were chosen, keep that choice and loosen compression level first
    if (matches.length === 0 && answers.types.length && answers.frequency) {
      matches = products.filter((p) => matchesFilters(p, false, true, false, false));
      relaxedNote = 'compression level';
    }
    // Still nothing: drop the garment choice, keep compression level
    if (matches.length === 0 && answers.types.length) {
      matches = products.filter((p) => matchesFilters(p, true, false, false, false));
      relaxedNote = 'garment type';
    }
    if (matches.length === 0 && answers.frequency) {
      matches = products.filter((p) => matchesFilters(p, true, true, false, false));
      relaxedNote = 'compression level';
    }
    if (matches.length === 0 && answers.purpose) {
      matches = products.filter((p) => matchesFilters(p, true, true, true, false));
      relaxedNote = 'activity';
    }
    if (matches.length === 0 && answers.gender) {
      matches = products.filter((p) => matchesFilters(p, true, true, true, true));
      relaxedNote = 'gender';
    }
    // In-stock first, then best compression fit, then the original order
    matches = matches
      .map((p, i) => ({ p, i, fit: fitScore(p) === null ? 2 : fitScore(p) }))
      .sort((a, b) =>
        (b.p.available !== false) - (a.p.available !== false) || a.fit - b.fit || a.i - b.i)
      .map((x) => x.p);
    return { matches, relaxedNote };
  }

  function renderGrid() {
    const toShow = currentMatches.slice(0, visibleCount);
    grid.innerHTML = toShow
      .map((p, i) => {
        const badges = [];
        if (p.compression) badges.push(`<span class="spf__badge spf__badge--compression">${escapeHtml(p.compression)}</span>`);
        const soldOut = p.available === false;
        if (soldOut) badges.push(`<span class="spf__badge spf__badge--soldout">Sold out</span>`);
        return `
        <a class="spf__card${soldOut ? ' is-soldout' : ''}" href="${p.url}" data-title="${escapeHtml(p.title)}" data-position="${i + 1}">
          ${p.image ? `<img class="spf__card-image" src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
          <div class="spf__card-body">
            ${badges.length ? `<div class="spf__card-badges">${badges.join('')}</div>` : ''}
            <p class="spf__card-title">${escapeHtml(p.title)}</p>
            <p class="spf__card-price">${p.price}</p>
          </div>
        </a>`;
      })
      .join('');
    loadMoreBtn.style.display = currentMatches.length > visibleCount ? 'block' : 'none';
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function showResults() {
    stepEls.forEach((s) => s.classList.remove('is-active'));
    resultsPanel.classList.add('is-active');
    visibleCount = PAGE_SIZE;

    const { matches, relaxedNote } = findMatches();
    currentMatches = matches;

    trackFinder('fit_finder_complete', {
      purpose: answers.purpose || 'none',
      frequency: answers.frequency || 'none',
      gender: answers.gender || 'none',
      garment: answers.types.length ? answers.types.join(', ') : 'any',
      results_count: matches.length,
      relaxed: relaxedNote || 'none',
    });

    if (matches.length === 0) {
      grid.innerHTML = '';
      emptyMsg.style.display = 'block';
      emptyMsg.querySelector('p').textContent =
        "We couldn't find any products matching your answers. Try starting over with different options.";
      loadMoreBtn.style.display = 'none';
      resultsTitle.textContent = 'No matches found';
      return;
    }

    emptyMsg.style.display = relaxedNote ? 'block' : 'none';
    if (relaxedNote) {
      emptyMsg.querySelector('p').textContent =
        "We widened your " + relaxedNote + " to find these closest matches.";
    }
    resultsTitle.textContent = 'Your matches (' + matches.length + ')';
    renderGrid();
  }

  updateSequence();
  showStepByKey('purpose');
})();